var makeBreakpoint = (min, max) => "@media screen and (min-width: ".concat(min, "px) ").concat(max ? "and (max-width: ".concat(max, "px)") : '');
export var mobile340 = makeBreakpoint(340, 379);
export var mobile380 = makeBreakpoint(380, 419);
export var mobile420 = makeBreakpoint(420, 459);
export var mobile460 = makeBreakpoint(460, 499);
export var mobile500 = makeBreakpoint(500, 539);
export var mobile540 = makeBreakpoint(540, 579);
export var mobile580 = makeBreakpoint(580);